import { useParams } from 'react-router';
import { type LocalModelWithPermissionsSpecsFragment } from '../../../api/fragments/LocalModelWithPermissionsSpecs';
import { useGetVehicleQuery } from '../../../api/queries/getVehicle';
import LoadingElement from '../../../components/LoadingElement';
import NotFoundResult from '../../../components/results/NotFoundResult';
import ModelDetailsPage from './ModelDetailsPage';

const ModelDetails = () => {
    const { modelId } = useParams<{ modelId: string }>();

    const { data, loading } = useGetVehicleQuery({
        fetchPolicy: 'network-only',
        variables: { id: modelId },
    });

    const model = data?.vehicle as LocalModelWithPermissionsSpecsFragment;

    if (!model && loading) {
        return <LoadingElement />;
    }

    if (!model) {
        return <NotFoundResult />;
    }

    return <ModelDetailsPage model={model} />;
};

export default ModelDetails;
